import { Pipe, PipeTransform } from '@angular/core';
import { getFormattedNotificationTimestamp } from '../shared/utils/notification-display.util';

/**
 * Pure pipe that formats a notification timestamp for display.
 * Being pure, Angular memoizes the result per input value, so the date is parsed
 * once per row instead of on every change-detection cycle inside *ngFor.
 */
@Pipe({ name: 'notificationTimestamp', standalone: true })
export class NotificationTimestampPipe implements PipeTransform {
  transform(timestamp: string): string {
    return getFormattedNotificationTimestamp(timestamp);
  }
}
